module.exports = __webpack_public_path__ + "images/save-view-dropdown-5c0a86c3.svg";